<template>
  <spinner-container :loading="loading">
    <back-btn />
    <v-container fluid>
      <v-row justify="center">
        <v-col md="5">
        <procedure-form @emitData="update" :procedure="procedure"/>
        </v-col>
      </v-row>
    </v-container>
  </spinner-container>
</template>

<script>
import BackBtn from '@/components/navigation/BackBtn.vue';
import SpinnerContainer from '@/components/container/SpinnerContainer.vue';

import { mapState } from "vuex";
import ProcedureForm from '../../components/procedure/ProcedureForm.vue';

export default {
  components: {
    BackBtn,
    SpinnerContainer,
    ProcedureForm,
  },
  computed: {
    ...mapState("Procedure", ["procedure"]),
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    update(data) {
      this.$store.dispatch("Procedure/update", data).then(() => {
        this.$router.push('/procedure')
      })
    },
  },
  created() {
    this.$store.dispatch("Procedure/getEach", this.$route.params.id);
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
